import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-x-inner-input',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './x-inner-input.component.html',
  styleUrl: './x-inner-input.component.less',
})
export class XInnerInputComponent {
  @HostBinding('class') @Input() orientation: 'vertical' | 'horizontal' | 'both' | 'none' = 'horizontal';

  @Input() disabled: boolean = false;
  @Input() ngModel: string | number | undefined | null = '';
  @Input() readonly: boolean = false;
  @Output() ngModelChange = new EventEmitter<string>();
  @Input() fontClass = 'body-1-medium';
  @Input() placeholder = '';
}
